import { inject, injectable } from 'inversify';
import {
  VerificationRepositoryInterface,
  VerificationErrorCode,
  VerificationError,
} from '../domain/VerificationRepositoryInterface';
import VerificationService from 'src/features/verification/data/service/VerificationService';
import { isAxiosError } from 'axios';
import {
  DefaultSendVerificationCodeParams,
  DefaultVerifyCodeParams,
} from 'src/features/verification/data/service/VerificationService.types';

@injectable()
class VerificationRepository implements VerificationRepositoryInterface {
  @inject(VerificationService)
  private readonly verificationService!: VerificationService;

  public async sendVerificationCode(params: DefaultSendVerificationCodeParams) {
    const response =
      await this.verificationService.sendVerificationCode(params);

    return response.data;
  }

  public async verifyCode(params: DefaultVerifyCodeParams) {
    try {
      const response = await this.verificationService.verifyCode(params);

      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  private handleError(error: unknown) {
    if (
      isAxiosError(error) &&
      error.response &&
      error.response.data &&
      error.response.data.code
    ) {
      const code = error.response?.data?.code as VerificationErrorCode;

      throw new VerificationError(code);
    }
    throw new VerificationError(VerificationErrorCode.UnknownError);
  }
}

export default VerificationRepository;
